<!-- 证券从业考试 -->
<template>
  <div class="el-TCoachExamList">
    <el-row class="content_block mb30">
      <TitleInfo title="从业考证" :titleImg="kaoshi"></TitleInfo>
      <el-row class="pt20 pl20 coachExamList_list">
        <ul>
          <template v-for="(item, index) in myAppsList" >
            <li :key="index">
              <el-image class="thirdParty_img c_p mr20" :src="js2"></el-image>
              <el-row>
                <p class="limit_line_one fontB" style="margin: 0 0 10px 0;">{{item.generalQuestionSettingName}}</p>
                <p class="limit_line_one" style="margin: 0 0 10px 0;">题{{$chineseNum(index)}}</p>
                <p class="limit_line_one" style="margin: 0 0 10px 0;">题目数量：{{item.questionTotalCount}}</p>
                <div style="float: right;width: calc(100% - 220px);margin-top: 6px;">
                  <span class="but_icon" style="font-size: 25px;line-height: 55px;color: #F83131;">

                  </span>
                  <span class="but_icon">
                    <i class="el-icon-data-analysis c_p" style="font-size: 25px;color: #06BFCF;" @click="startExam(item)"></i>
                    <br>
                    <el-link style="margin-top: 5px;" :underline="false" @click="startExam(item)">统计</el-link>
                  </span>
                  <span class="but_icon">
                    <i class="el-icon-document c_p" style="font-size: 25px;color: #FF6554;" @click="resultDetails(item)"></i>
                    <br>
                    <el-link style="margin-top: 5px;" :underline="false" @click="resultDetails(item)">查看试题</el-link>
                  </span>
                </div>
              </el-row>
            </li>
          </template>
        </ul>
      </el-row>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-sizes="[6, 12, 20, 40]"
        :page-size="limit"
        background
        class="m20 t_r"
        :hide-on-single-page="true"
        layout="sizes, prev, pager, next,jumper"
        :total="total">
      </el-pagination>
    </el-row>
  </div>
</template>

<script>
import TitleInfo from "@/components/TitleInfo"; //页面头部
export default {
  name: "CoachExamList",
  components: {
  	TitleInfo,
  },
  data() {
    return {
      courseId:this.$route.query.courseId,
      courseInfoName:this.$route.query.courseInfoName,
      kaoshi:require("../../images/coach/kaoshi@2x.png"),
      js2:require("../../images/course/js2.png"),
      myAppsList:[],
      total: 0,
      limit:6,
      page:1,
      timeIn:null
    };
  },
  created() {
    this.getInfo();
    //this.addSystem();
  },
  mounted() {

  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.limit = val;
      this.getInfo();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getInfo();
    },
    getInfo(){
      let param = {
        limit:this.limit,
        page:this.page,
        businessId:this.courseId,
        businessType:"FROM_SYSTEM",
        generalQuestionSettingPushStatus:"PUSH",
        generalQuestionSettingType: "EXAM",
      }
      this.$post("/api/generalQuestionSetting/getPageList.do",param).then((ret) =>{
        if(ret.code == 0){
          this.total = Number(ret.count);
          this.myAppsList = ret.data;
          if(!this.$isEmpty(this.myAppsList)){
            for(let i = 0;i< this.myAppsList.length;i++){
              for(let o = 0;o< this.myAppsList[i].questionSettingOptions.length;o++){
                this.myAppsList[i].questionTotalCount = Number(this.myAppsList[i].questionTotalCount || 0) + Number(this.myAppsList[i].questionSettingOptions[o].selectCount);
              }
            }
          }
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    startExam(item){ //考试统计
      this.$router.push({name:'TCoachExamDetailed',query:{generalQuestionSettingId:item.generalQuestionSettingId,courseInfoName:this.courseInfoName}});
    },
    resultDetails(item){ //详情
      this.$router.push({name:'TCoachExamQuestions',query:{generalQuestionSettingId:item.generalQuestionSettingId,courseInfoName:this.courseInfoName}});
    },
    addSystem(){ //模块使用统计
      //模块使用时间 开始
      const timeNum = this.$ls.get('timeNum'); //获取统一
      this.timeIn = setInterval(()=>{
        let param = {
          firstName:"考证辅导",//一级名称
          secondName:this.courseInfoName,//二级名称
          useDuration:timeNum / 1000 / 60//单次使用时长（单位：分钟）
        }
        this.$addSystemUseLog(param);
      },timeNum);
      // 结束
    }
  },
  beforeDestroy() {
    clearInterval(this.timeIn); //关闭定时
  }
};
</script>
 <style  lang="less">
  .el-TCoachExamList{
    padding: 20px 20px 0;
    .coachExamList_list{
      min-height: 320px;overflow: auto;
      ul{
        list-style-type:none;
        margin: 0;
        padding: 0;
      }
      li{
        float: left;
        width: calc(33.3% - 65px);
        padding: 20px;
        margin: 0 20px 20px 0;
        border: 1px solid #E1E1E1;
        font-size: 14px;
      }
      .but_icon{
        width: 33%;height: 55px;float: left;text-align: center;
      }
    }

    .content_block{
      background-color: #ffffff;
      .el-divider--horizontal{
        margin: 0;
      }
    }
    .thirdParty_img{
      width: 200px;
      height: 148px;
      float: left;
    }
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/certificate/TCoachExamList.vue